/**
 * catalog `sttSupported`：缺省/undefined 视为支持（兼容旧端点）。
 */
export function isLangSttSupported(lang: { sttSupported?: boolean } | null | undefined): boolean {
  if (!lang) {
    return true
  }
  return lang.sttSupported !== false
}
